 // 取面对象 中心点
 export default function (lnglatarr) {
    var total = lnglatarr.length;
    var X = 0, Y = 0, Z = 0;
    lnglatarr.forEach(function (lnglat) {
    
        var lng = lnglat.lon * Math.PI / 180;
        var lat = lnglat.lat * Math.PI / 180;
   
        var x, y, z;
        x = Math.cos(lat) * Math.cos(lng);
        y = Math.cos(lat) * Math.sin(lng);
        z = Math.sin(lat);
        X += x;
        Y += y;
        Z += z;
    });
    X = X / total;
    Y = Y / total;
    Z = Z / total;

    var Lng = Math.atan2(Y, X);
    var Hyp = Math.sqrt(X * X + Y * Y);
    var Lat = Math.atan2(Z, Hyp);
    return { lng: Lng * 180 / Math.PI, lat: Lat * 180 / Math.PI };
}
